 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER_PA from '@/components/html/00_Cover_Pa'
 import HTML01_SERIES_P from '@/components/html/01_Series_P'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML04_DEDICATI from '@/components/html/04_Dedicati'
 import HTML05_FRONT_MA from '@/components/html/05_Front_Ma'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_TABLET from '@/components/html/07_Tablet'
 import HTML08_POSSIBLE from '@/components/html/08_Possible'
 import HTML09_SEROTONI from '@/components/html/09_Serotoni'
 import HTML10_OR_A_WOM from '@/components/html/10_Or_a_Wom'
 import HTML11_BRIEF_DR from '@/components/html/11_Brief_Dr'
 import HTML12_POEM_WRI from '@/components/html/12_Poem_Wri'
 import HTML13_EAVESDRI from '@/components/html/13_Eavesdri'
 import HTML14_MY_RECEN from '@/components/html/14_My_Recen'
 import HTML15_IN_THE_W from '@/components/html/15_In_the_W'
 import HTML16_VOWS___ from '@/components/html/16_Vows___'
 import HTML17_BLOWN_SN from '@/components/html/17_Blown_Sn'
 import HTML18_STRANGE from '@/components/html/18_Strange'
 import HTML19_NOT_KNOW from '@/components/html/19_Not_Know'
 import HTML20_SUSTENAN from '@/components/html/20_Sustenan'
 import HTML21_PARTIAL from '@/components/html/21_Partial'
 import HTML22_WINDOWSI from '@/components/html/22_Windowsi'
 import HTML23_TARNATIO from '@/components/html/23_Tarnatio'
 import HTML24_WEEKLY_A from '@/components/html/24_Weekly_A'
 import HTML25_MAY_____ from '@/components/html/25_May_____'
 import HTML26_THAT_BLU from '@/components/html/26_That_Blu'
 import HTML27_I_CANONI from '@/components/html/27_I_Canoni'
 import HTML28_THEY_TIE from '@/components/html/28_They_Tie'
 import HTML29_GHAZAL_I from '@/components/html/29_Ghazal_i'
 import HTML30_INSCRIPT from '@/components/html/30_Inscript'
 import HTML31_SEPTEMBE from '@/components/html/31_Septembe'
 import HTML32_THE_TAXI from '@/components/html/32_The_Taxi'
 import HTML33_HAMMOCK from '@/components/html/33_Hammock'
 import HTML34_STUBBORN from '@/components/html/34_Stubborn'
 import HTML35_NOSTRUMS from '@/components/html/35_Nostrums'
 import HTML36_THINGS_B from '@/components/html/36_Things_B'
 import HTML37_COMES_TO from '@/components/html/37_Comes_to'
 import HTML38_FEBRUARY from '@/components/html/38_February'
 import HTML39_STILL_LI from '@/components/html/39_Still_Li'
 import HTML40_STUDY_FO from '@/components/html/40_Study_fo'
 import HTML41_POEM_WIT from '@/components/html/41_Poem_wit'
 import HTML42_WINTERIN from '@/components/html/42_Winterin'
 import HTML43_FLUVIAL_ from '@/components/html/43_Fluvial_'
 import HTML44_THE_ROOF from '@/components/html/44_The_Roof'
 import HTML45_VESPERS from '@/components/html/45_Vespers'
 import HTML46_THE_FORB from '@/components/html/46_The_Forb'
 import HTML47_SMALL_FI from '@/components/html/47_Small_Fi'
 import HTML48_NAIVE_ME from '@/components/html/48_Naive_Me'
 import HTML49_GROVE from '@/components/html/49_Grove'
 import HTML50_TRIMMING from '@/components/html/50_Trimming'
 import HTML51_A_TOAST from '@/components/html/51_A_Toast'
 import HTML52_NOTES from '@/components/html/52_Notes'
 import HTML53_ACKNOWLE from '@/components/html/53_Acknowle'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_Tablet",
 			"name" : "html/07_Tablet",
 			"component" : HTML07_TABLET
 		},
 		{
 			"path" : "/html/08_Possible",
 			"name" : "html/08_Possible",
 			"component" : HTML08_POSSIBLE
 		},
 		{
 			"path" : "/html/09_Serotoni",
 			"name" : "html/09_Serotoni",
 			"component" : HTML09_SEROTONI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js